export enum ControlTypeEnum {
  LOSOWA = 'LOSOWA',
  NATYCHMIASTOWA = 'NATYCHMIASTOWA',
}

export enum ControlTypeDescriptionEnum {
  LOSOWA = 'control.type.random',
  NATYCHMIASTOWA = 'control.type.instant',
}
